/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureMcaSubscription extends models.ServiceAccountNativeDetailsBaseForAzureSubscription {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureMcaSubscription");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureMcaSubscription.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureMcaSubscription>): ServiceAccountNativeDetailsForAzureMcaSubscription {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureMcaSubscription(), model);
        ServiceAccountNativeDetailsForAzureMcaSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureMcaSubscription>): ServiceAccountNativeDetailsForAzureMcaSubscription {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureMcaSubscription.newInstance(<ServiceAccountNativeDetailsForAzureMcaSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureMcaSubscription) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureMcaSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureMcaSubscription): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzureSubscription.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureMcaSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
